var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5E5D8D;}\n\t.st1{fill:#FFD3A4;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "checklist-flat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.8,38.4h-57.6c4.2,5.5,6.5,12.3,6.5,19.2V96c0,17.7-14.3,32-32,32H198.4c-17.7,0-32-14.3-32-32V57.6 c0-6.9,2.3-13.7,6.4-19.2h-57.6c-35.3,0.1-63.9,28.7-64,64V448c0.1,35.3,28.7,63.9,64,64h281.6c35.3-0.1,63.9-28.7,64-64V102.4 C460.7,67.1,432.1,38.5,396.8,38.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.4,230.4H256c-7.1,0-12.8-5.7-12.8-12.8s5.7-12.8,12.8-12.8l0,0h102.4c7.1,0,12.8,5.7,12.8,12.8 S365.5,230.4,358.4,230.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.2,243.2c-2,0-3.9-0.5-5.7-1.4L147.9,229c-6.3-3.2-8.9-10.9-5.7-17.2c3.2-6.3,10.9-8.9,17.2-5.7l15.5,7.8 l19.3-29c4-5.9,11.9-7.4,17.8-3.4c5.8,3.9,7.4,11.8,3.5,17.6l-25.6,38.4C187.5,241.1,183.5,243.2,179.2,243.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.4,320H256c-7.1,0-12.8-5.7-12.8-12.8c0-7.1,5.7-12.8,12.8-12.8l0,0h102.4c7.1,0,12.8,5.7,12.8,12.8 C371.2,314.3,365.5,320,358.4,320z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.2,332.8c-2,0-3.9-0.5-5.7-1.4l-25.6-12.8c-6.3-3.2-8.9-10.9-5.7-17.2c3.2-6.3,10.9-8.9,17.2-5.7l15.5,7.8 l19.3-29c4-5.9,11.9-7.4,17.8-3.4c5.8,3.9,7.4,11.8,3.5,17.6l-25.6,38.4C187.5,330.7,183.5,332.8,179.2,332.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.4,409.6H256c-7.1,0-12.8-5.7-12.8-12.8c0-7.1,5.7-12.8,12.8-12.8l0,0h102.4c7.1,0,12.8,5.7,12.8,12.8 C371.2,403.9,365.5,409.6,358.4,409.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.2,422.4c-2,0-3.9-0.5-5.7-1.4l-25.6-12.8c-6.3-3.2-8.9-10.9-5.7-17.2c3.2-6.3,10.9-8.9,17.2-5.7l0,0 l15.5,7.8l19.3-29c4-5.9,11.9-7.4,17.8-3.4c5.8,3.9,7.4,11.8,3.5,17.6l-25.6,38.4C187.5,420.3,183.5,422.4,179.2,422.4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M313.6,25.6h-21.4c-7-20-28.9-30.5-48.9-23.4c-11,3.9-19.6,12.5-23.4,23.4h-21.4c-17.7,0-32,14.3-32,32V96 c0,17.7,14.3,32,32,32h115.2c17.7,0,32-14.3,32-32V57.6C345.6,39.9,331.3,25.6,313.6,25.6z M256,51.2c-7.1,0-12.8-5.7-12.8-12.8 c0-7.1,5.7-12.8,12.8-12.8s12.8,5.7,12.8,12.8c0,0,0,0,0,0C268.8,45.5,263.1,51.2,256,51.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.7760c29c663363f973f343d10d64f450.svg";
export { ForwardRef as ReactComponent };